import React from 'react'

const SamplingService = () => {
  return (
    <div>SamplingService</div>
  )
}

export default SamplingService